import './ServiceCard.css';

const ServiceCard = ({ number, title, description, image }) => {
  return (
    <div className="service-card">
      {image && <img src={image} alt={title} className="service-image" />}
      <div className="service-content">
        <span className="service-number">{number}</span>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default ServiceCard;